export default "__VITE_ASSET__bf21a06d__"